import {
  vBoolean,
  vObject,
  vOptional,
  type vOutput,
  vString,
} from '../validation/index.ts'

export const twoFactorSetupSchema = vObject({
  // No input required for initial setup
})

export const twoFactorVerifySchema = vObject({
  token: vString(),
})

export const twoFactorCompleteSetupSchema = vObject({
  token: vString(),
})

export const twoFactorDisableSchema = vObject({
  token: vString(),
})

export const twoFactorLoginSchema = vObject({
  token: vString(),
  userId: vString(),
  accountId: vString(),
  isBackupCode: vOptional(vBoolean()),
})

export const twoFactorRegenerateBackupCodesSchema = vObject({
  token: vString(),
})

// Response types
export interface TwoFactorSetupResponse {
  secret: string
  qrCodeUrl: string
  backupCodes: string[]
}

export interface TwoFactorStatusResponse {
  enabled: boolean
  setupCompleted: boolean
}

export interface TwoFactorBackupCodesResponse {
  backupCodes: string[]
}

// DTO types
export type TwoFactorSetupDTO = vOutput<typeof twoFactorSetupSchema>
export type TwoFactorVerifyDTO = vOutput<typeof twoFactorVerifySchema>
export type TwoFactorCompleteSetupDTO = vOutput<
  typeof twoFactorCompleteSetupSchema
>
export type TwoFactorDisableDTO = vOutput<typeof twoFactorDisableSchema>
export type TwoFactorLoginDTO = vOutput<typeof twoFactorLoginSchema>
export type TwoFactorRegenerateBackupCodesDTO = vOutput<
  typeof twoFactorRegenerateBackupCodesSchema
>
